<template>
    <icon :width="30" :height="20" viewBox="0 0 30 20" fill="#1c7cdc">
        <rect x="10" y="5" width="11" height="1" />
        <rect x="10" y="15" width="11" height="1" />
        <polygon
                points="29.48 10.27 24.23 5.03 23.52 5.73 27.79 10 10 10 10 11 27.79 11 23.52 15.27 24.23 15.97 29.48 10.73 29.7 10.5 29.48 10.27"
        />
    </icon>
</template>

<script>
    import Icon from './Icon.vue';

    export default {
        components: {
            Icon,
        },
    }
</script>

<style scoped>

</style>